import { useEffect, useState } from 'react';
import * as PopperJS from 'popper.js';
import { Manager, Reference, Popper as ReactPopper } from 'react-popper';

import { IInjectedStylingProps, withStyling } from './higher-order';

import styles from './popper.module.scss';

export interface IPopperProps extends IInjectedStylingProps {
	children: React.JSX.Element | string;
	id: string;
	isOpen: boolean;
	placement?: PopperJS.Placement;
	placementOffset?: [number, number];
	toggleButton: React.JSX.Element;
	toggleButtonFullWidth?: boolean;
	updatePopper?: any[]; // If this prop changes, the popper will update. Mostly used for re-positioning.
	zIndex?: number;
}

const PopperComponent = (props: IPopperProps): React.JSX.Element => {
	const [updatePopper, setUpdatePopper] = useState(false);
	const { children, toggleButton, toggleButtonFullWidth, placementOffset, zIndex } = props;

	useEffect(() => {
		setUpdatePopper(!updatePopper);
	}, [props.updatePopper]);

	return (
		<Manager>
			<Reference>
				{({ ref }): React.JSX.Element => (
					<div
						className={props.styling?.getStyle(styles, 'popperButton')}
						ref={ref}
						style={{ width: toggleButtonFullWidth ? '100%' : 'initial' }}
					>
						{toggleButton}
					</div>
				)}
			</Reference>

			{props.isOpen && (
				<ReactPopper
					placement={props.placement || 'bottom-start'}
					modifiers={[
						{ name: 'preventOverflow', enabled: false },
						{ name: 'hide', enabled: false },
						{ name: 'offset', options: { offset: placementOffset || [0, 0] } },
						{ name: 'updatePopperOnPropertyChange', enabled: updatePopper, phase: 'afterRead' } // The property will change based on the updatePopper prop and will then update the popper.
					]}
				>
					{({ placement, ref, style }): React.JSX.Element => (
						<div ref={ref} style={{ ...style, ...(zIndex && { zIndex }) }} data-placement={placement}>
							{children}
						</div>
					)}
				</ReactPopper>
			)}
		</Manager>
	);
};

const Popper = withStyling(PopperComponent);
export { Popper };
